import { useEffect, useRef, useState } from 'react';

import { AppStateStatus } from 'react-native';

const useIsLive = (
    startTime?: number,
    endTime?: number,
    appState?: AppStateStatus,
) => {
    const [isLive, setIsLive] = useState(false);
    const setLiveTimer = useRef<NodeJS.Timeout>(undefined);
    const unsetLiveTimer = useRef<NodeJS.Timeout>(undefined);

    useEffect(() => {
        // Set timeout if appState is 'active', if app needs to handle long background period.
        // OR
        // Set timeout if appState was not provided as a prop to EPG component, which means app will not handle long background period.
        if (
            (appState === 'active' || appState === undefined) &&
            startTime !== undefined &&
            endTime !== undefined
        ) {
            const now = Date.now();

            if (now < startTime) {
                // FUTURE
                setIsLive(false);
                setLiveTimer.current = setTimeout(() => {
                    setIsLive(true);
                }, startTime - now);
                unsetLiveTimer.current = setTimeout(() => {
                    setIsLive(false);
                }, endTime - now);
            }
            if (now >= startTime && now < endTime) {
                // LIVE
                setIsLive(true);
                unsetLiveTimer.current = setTimeout(() => {
                    setIsLive(false);
                }, endTime - now);
            } else {
                // PAST
                setIsLive(false);
            }
        }

        return () => {
            clearTimeout(setLiveTimer.current);
            clearTimeout(unsetLiveTimer.current);
        };
    }, [startTime, endTime, appState]);

    return isLive;
};

export default useIsLive;
